export default "__VITE_ASSET__e9scjKxZ__"